var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-analysis 1",
    clipPath: "url(#clip0_607_2057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.75 62.7966C91.8358 62.7966 91.0938 62.0629 91.0938 61.1486V61.1321C91.0938 60.2178 91.8358 59.4758 92.75 59.4758C93.6642 59.4758 94.4062 60.2178 94.4062 61.1321C94.4062 62.0463 93.6642 62.7966 92.75 62.7966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M94.4062 102.688C94.4062 104.509 92.9156 106 91.0938 106H14.9062C13.0844 106 11.5938 104.509 11.5938 102.688V3.3125C11.5938 1.49062 13.0844 0 14.9062 0H79.5L81.1562 1.65625V13.25H92.75L94.4062 14.9062V102.688Z",
    fill: "#F0E7DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M94.4062 14.9062H82.8125C80.9906 14.9062 79.5 13.4156 79.5 11.5938V0L94.4062 14.9062Z",
    fill: "#C8AD90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M84.4688 64.5938C96.3601 64.5938 106 54.9539 106 43.0625C106 31.1711 96.3601 21.5312 84.4688 21.5312C72.5774 21.5312 62.9375 31.1711 62.9375 43.0625C62.9375 54.9539 72.5774 64.5938 84.4688 64.5938Z",
    fill: "#C8AD90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M53 16.5625H29.8125C28.8983 16.5625 28.1562 15.8205 28.1562 14.9062C28.1562 13.992 28.8983 13.25 29.8125 13.25H53C53.9142 13.25 54.6562 13.992 54.6562 14.9062C54.6562 15.8205 53.9142 16.5625 53 16.5625Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53 23.1875H23.1875C22.2733 23.1875 21.5312 22.4455 21.5312 21.5312C21.5312 20.617 22.2733 19.875 23.1875 19.875H53C53.9142 19.875 54.6562 20.617 54.6562 21.5312C54.6562 22.4455 53.9142 23.1875 53 23.1875Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M53 29.8125H23.1875C22.2733 29.8125 21.5312 29.0705 21.5312 28.1562C21.5312 27.242 22.2733 26.5 23.1875 26.5H53C53.9142 26.5 54.6562 27.242 54.6562 28.1562C54.6562 29.0705 53.9142 29.8125 53 29.8125Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.4375 36.4375H23.1875C22.2733 36.4375 21.5312 35.6955 21.5312 34.7812C21.5312 33.867 22.2733 33.125 23.1875 33.125H36.4375C37.3518 33.125 38.0938 33.867 38.0938 34.7812C38.0938 35.6955 37.3518 36.4375 36.4375 36.4375Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M81.1562 74.5312H71.2188C70.3045 74.5312 69.5625 73.7892 69.5625 72.875C69.5625 71.9608 70.3045 71.2188 71.2188 71.2188H81.1562C82.0705 71.2188 82.8125 71.9608 82.8125 72.875C82.8125 73.7892 82.0705 74.5312 81.1562 74.5312Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M81.1562 81.1562H64.5938C63.6795 81.1562 62.9375 80.4142 62.9375 79.5C62.9375 78.5858 63.6795 77.8438 64.5938 77.8438H81.1562C82.0705 77.8438 82.8125 78.5858 82.8125 79.5C82.8125 80.4142 82.0705 81.1562 81.1562 81.1562Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M81.1562 87.7812H64.5938C63.6795 87.7812 62.9375 87.0392 62.9375 86.125C62.9375 85.2108 63.6795 84.4688 64.5938 84.4688H81.1562C82.0705 84.4688 82.8125 85.2108 82.8125 86.125C82.8125 87.0392 82.0705 87.7812 81.1562 87.7812Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M71.2188 94.4062H64.5938C63.6795 94.4062 62.9375 93.6642 62.9375 92.75C62.9375 91.8358 63.6795 91.0938 64.5938 91.0938H71.2188C72.133 91.0938 72.875 91.8358 72.875 92.75C72.875 93.6642 72.133 94.4062 71.2188 94.4062Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M53 46.375H29.8125C28.8983 46.375 28.1562 45.633 28.1562 44.7188C28.1562 43.8045 28.8983 43.0625 29.8125 43.0625H53C53.9142 43.0625 54.6562 43.8045 54.6562 44.7188C54.6562 45.633 53.9142 46.375 53 46.375Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M36.4375 53H23.1875C22.2733 53 21.5312 52.258 21.5312 51.3438C21.5312 50.4295 22.2733 49.6875 23.1875 49.6875H36.4375C37.3518 49.6875 38.0938 50.4295 38.0938 51.3438C38.0938 52.258 37.3518 53 36.4375 53Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M43.0625 36.4375C43.9772 36.4375 44.7188 35.696 44.7188 34.7812C44.7188 33.8665 43.9772 33.125 43.0625 33.125C42.1478 33.125 41.4062 33.8665 41.4062 34.7812C41.4062 35.696 42.1478 36.4375 43.0625 36.4375Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M43.0625 53C43.9772 53 44.7188 52.2585 44.7188 51.3438C44.7188 50.429 43.9772 49.6875 43.0625 49.6875C42.1478 49.6875 41.4062 50.429 41.4062 51.3438C41.4062 52.2585 42.1478 53 43.0625 53Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M77.8438 94.4062C78.7585 94.4062 79.5 93.6647 79.5 92.75C79.5 91.8353 78.7585 91.0938 77.8438 91.0938C76.929 91.0938 76.1875 91.8353 76.1875 92.75C76.1875 93.6647 76.929 94.4062 77.8438 94.4062Z",
    fill: "#57555C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M84.4688 23.1875V43.0625H64.5938C64.5938 32.0816 73.4878 23.1875 84.4688 23.1875Z",
    fill: "#FFB74F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M98.5304 57.1241C94.9363 60.7181 89.9675 62.9375 84.4688 62.9375C78.97 62.9375 74.0013 60.7181 70.4072 57.1241L84.4688 43.0625L98.5304 57.1241Z",
    fill: "#84CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M104.344 43.0625C104.344 48.5613 102.124 53.53 98.5303 57.1241L84.4688 43.0625V23.1875C95.4497 23.1875 104.344 32.0816 104.344 43.0625Z",
    fill: "#00A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M84.4688 43.0625L70.4072 57.1241C66.8131 53.53 64.5938 48.5612 64.5938 43.0625H84.4688Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M8.28125 94.4062V77.8438C8.28125 76.9312 9.02491 76.1875 9.9375 76.1875H16.5625C17.4751 76.1875 18.2188 76.9312 18.2188 77.8438V94.4062H8.28125Z",
    fill: "#FFB74F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M18.2188 94.4062V71.2188C18.2188 70.3062 18.9624 69.5625 19.875 69.5625H26.5C27.4126 69.5625 28.1562 70.3062 28.1562 71.2188V94.4062H18.2188Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M28.1562 94.4062V74.5312C28.1562 73.6187 28.8999 72.875 29.8125 72.875H36.4375C37.3501 72.875 38.0938 73.6187 38.0938 74.5312V94.4062H28.1562Z",
    fill: "#84CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M38.0938 94.4062V62.9375C38.0938 62.0249 38.8374 61.2812 39.75 61.2812H46.375C47.2876 61.2812 48.0312 62.0249 48.0312 62.9375V94.4062H38.0938Z",
    fill: "#00A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M54.6562 96.0625H1.65625C0.742 96.0625 0 95.3205 0 94.4062C0 93.492 0.742 92.75 1.65625 92.75H54.6562C55.5705 92.75 56.3125 93.492 56.3125 94.4062C56.3125 95.3205 55.5705 96.0625 54.6562 96.0625Z",
    fill: "#C8AD90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_2057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.9813d186fa6dcbee38a96a2a6c4e1c8b.svg";
export { ForwardRef as ReactComponent };